import gql from 'graphql-tag';
import { Fragments } from '@shared/api';

export const getNotificationPreference = gql`
  query GetNotificationPreferenceQuery($input: NotificationPreferenceInput!) {
    getNotificationPreference(input: $input) {
      ...NotificationPreference
    }
  }

  ${Fragments.notifications.notificationPreference}
`;
